<template>
    <td class="vrm-table__nowrap sg-color-blue">
        <a :href="downloadUrl" download target="_blank">{{ text }}</a>
    </td>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-table-cell-file')
export default class VrmTableCellFile extends Vue {
    @Prop({ type: String, default: null })
    text;
    @Prop({ type: String, default: null })
    downloadUrl;
}
</script>
